var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1259 3.66984C29.9552 3.03649 29.6215 2.45889 29.1582 1.99453C28.6948 1.53017 28.1178 1.19526 27.4848 1.02311C25.1374 0.378666 15.7466 0.368175 15.7466 0.368175C15.7466 0.368175 6.35723 0.357684 4.00839 0.973656C3.37573 1.15372 2.79998 1.49338 2.33642 1.96001C1.87287 2.42665 1.53707 3.00459 1.36127 3.63837C0.742204 5.98536 0.736208 10.8532 0.736208 10.8532C0.736208 10.8532 0.730213 15.745 1.34478 18.068C1.68953 19.3524 2.70132 20.367 3.98741 20.7132C6.35873 21.3577 15.7241 21.3682 15.7241 21.3682C15.7241 21.3682 25.115 21.3786 27.4623 20.7642C28.0956 20.5923 28.6731 20.2582 29.1376 19.7948C29.6021 19.3314 29.9376 18.7547 30.1109 18.1219C30.7315 15.7765 30.736 10.9101 30.736 10.9101C30.736 10.9101 30.766 6.01683 30.1259 3.66984ZM12.7427 15.3628L12.7502 6.37052L20.5552 10.8742L12.7427 15.3628Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f7e21b8d096e495db9a8e15926c72490.svg";
export { ForwardRef as ReactComponent };